jQuery(document).ready(function ($) {
  if($('.component-image-slider').length){
    $('.component-image-slider .component-inner').slick({
      //autoplay: true,
      //autoplaySpeed: 2000,
      arrows: true,
      dots: false,
      speed: 1400,
      cssEase: 'ease-in-out',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: '<buttton class="slide-arrow next-arrow"><svg width="33" height="59" viewBox="0 0 33 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.93481 2.75L28.4922 29.5048L1.93481 56.2596" stroke="black" stroke-width="3"/></svg></button>',
      prevArrow: '<buttton class="slide-arrow prev-arrow"><svg width="33" height="59" viewBox="0 0 33 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.9343 2.75L4.37695 29.5048L30.9343 56.2596" stroke="black" stroke-width="3"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
      ]
    });
  }
});